import { type FC } from 'react'

interface Props {
  className?: string
  width?: number
  height?: number
  viewBox?: string
}

const Logo: FC<Props> = ({
  width = 115,
  height = 55,
  viewBox = '200 55 480 400',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    {...props}
    aria-hidden='true'
  >
    <path d='M778.8,176.3v119.1h-26.5v-119.1h26.5ZM600.6,176.3c0-65.9-53.4-119.2-119.2-119.2s-119.2,53.4-119.2,119.2h119.2l-119.2,119.2h238.5v-59.6h-59.6l59.6-59.6h0ZM301,57.1l-40.3,59.6-40.2-59.6H64l161,238.5L386,57.1h-85ZM693,176.3l46.7,119.1h-28l-7.8-21.6h-46.7l-7.9,21.6h-27.5l47.2-119.1h24ZM696.1,252.2l-15.4-42.5-15.6,42.5h30.9Z' />
  </svg>
)

export default Logo
